import { RechercheForm } from '@features/demande-remboursement/choix-dossier/models/recherche-form';
import { RechercheColonneEnum } from '@features/demande-remboursement/choix-dossier/models/recherche-colonne.enum';
import { OrderByEnum } from '@shared/models/common/orderby.enum';
import { DossierFacturableSearchCriteria } from '@features/demande-remboursement/choix-dossier/models/recherche-request';
import { DispositifUrlToCode } from '@shared/constants';

export class MesDossiersFunctions {
    static searchFormToDossierSearchCriteria(
        dispositif: string,
        siret: string,
        form: RechercheForm,
        dossiersSelectionnes?: string[],
        isDispositifFromUrl: boolean = true
    ): DossierFacturableSearchCriteria {
        const dispositifCode = isDispositifFromUrl ? DispositifUrlToCode.get(dispositif)! : dispositif;
        const dossierCriteria: DossierFacturableSearchCriteria = {
            siretOrganismeFormation: siret,
            dispositif: dispositifCode,

            page: form.page,
            orderBy: form.orderBy ?? OrderByEnum.DESC,
            orderByColumn: form.orderByColumn ?? RechercheColonneEnum.DATE_CREATION
        };

        if (form.nomStagiaire && form.nomStagiaire !== "") {
            dossierCriteria.nomStagiaire = form.nomStagiaire;
        }

        if (form.prenomStagiaire && form.prenomStagiaire !== "") {
            dossierCriteria.prenomStagiaire = form.prenomStagiaire;
        }

        if (form.numDossier && form.numDossier !== "") {
            dossierCriteria.numeroDossier = form.numDossier;
        }

        if (form.referenceFormation && form.referenceFormation !== "") {
            dossierCriteria.referenceFormation = form.referenceFormation;
        }

        if (form.dateDebutFormation) {
            dossierCriteria.dateDebutFormation = form.dateDebutFormation?.toLocaleDateString();
        }

        if (form.dateFinFormation) {
            dossierCriteria.dateFinFormation = form.dateFinFormation?.toLocaleDateString();
        }

        if (form.isDossierSelectionne) {
            dossierCriteria.isDossierSelectionne = true;
            dossierCriteria.dossiersSelectionnes = dossiersSelectionnes;
        }

        if (form.eligible) {
            dossierCriteria.isDossierEligible = true;
        }

        if (form.strictEligible) {
            dossierCriteria.isDossierStrictEligible = true;
        }

        if (form.isUpdateRequired) {
            dossierCriteria.isUpdateRequired = true;
        }

        return dossierCriteria;
    }

    static mapToRechercheColonneEnum(field: string | undefined) {
        if (field === RechercheColonneEnum['NUMERO_DOSSIER']) {
            return RechercheColonneEnum.NUMERO_DOSSIER;
        }
        if (field === RechercheColonneEnum['LIBELLE_FORMATION']) {
            return RechercheColonneEnum.LIBELLE_FORMATION;
        }
        if (field === RechercheColonneEnum['REFERENCE_FORMATION']) {
            return RechercheColonneEnum.REFERENCE_FORMATION;
        }
        if (field === RechercheColonneEnum['DATES_FORMATION']) {
            return RechercheColonneEnum.DATES_FORMATION;
        }
        if (field === RechercheColonneEnum['MONTANT_A_PAYER']) {
            return RechercheColonneEnum.MONTANT_A_PAYER;
        }
        if (field === RechercheColonneEnum['STAGIAIRES']) {
            return RechercheColonneEnum.STAGIAIRES;
        }
        return RechercheColonneEnum.DATE_CREATION;
    }
}
